import React, { Component } from 'react'

import { AbsoluteFlexColumn } from 'navigation-ui/modal-screen'
import { useNavigation } from 'navigation'


const ChromelessScreen = ({ children }) => {
  const navigation = useNavigation()
  const up = navigation.length > 1 && navigation[navigation.length - 2].href
  return (
    <AbsoluteFlexColumn>
      {React.cloneElement(React.Children.only(children), {back : up })}
    </AbsoluteFlexColumn>
  )
}

export default ChromelessScreen
